<template>
  <b-table
    bordered
    hover
    head-variant="light"
    :items="list"
    :fields="fields"
    fixed
    show-empty
    responsive
    :busy.sync="isLoading"
  >
    <template #empty>
      <div class="text-center text-info my-2">Không có dữ liệu</div>
    </template>
    <template #emptyfiltered="{ emptyFilteredText }">
      <h4>{{ emptyFilteredText }}</h4>
    </template>
  </b-table>
</template>

<script>
  export default {
    components: {},
    props: {
      list: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        isLoading: false,
        pagination: {
          queryString: '',
          sortField: '',
          sortType: '',
          page: 1,
          total: 0,
          limit: 20,
        },
        fields: [
          {
            key: 'ownerName',
            label: 'Name',
            sortable: false,
          },
          {
            key: 'masterName',
            label: 'Master',
            sortable: false,
          },
        ],
        // list: []
      }
    },

    filters: {},

    created() {
      //
    },

    mounted() {
      //
    },

    computed: {
      // ...mapGetters({
      //   dataPermission: 'role/dataPermission',
      // }),
    },

    methods: {
      async loadData() {
        try {
          this.isLoading = true
          // const res = await List({
          //   limit: this.pagination.limit,
          //   page: this.pagination.page,
          //   queryString: this.pagination.queryString,
          //   sort: {
          //     direction: this.pagination.sortType,
          //     properties: [this.pagination.sortField],
          //   }
          // });
          this.list = res.data
          this.pagination.total = res.paging.total
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
